<div class="copyable-text" (click)="copyText()">
  {{ text }} <i class="fal fa-copy"></i>
</div>
